import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  avatar: {
    width: '16px',
    height: '16px',
    fontSize: theme.size.sm,

    '& svg': {
      width: '16px',
      height: '16px'
    }
  },

  name: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 0.125rem 0 0.5rem',

    '& > span': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: '15ch'
    },

    '& > span.has-suffix': {
      marginRight: '0.125rem'
    }
  },

  close: {
    marginLeft: '0.25rem',
    minWidth: '14px',
    cursor: 'pointer'
  }
}))

export default useStyles
